module.exports = __webpack_public_path__ + "static/media/plik-wsadowy.668df80a.xlsx";